module.exports = require('./helpers/bundle-url').getBundleURL('hg7Qi') + "isgdlogo.94eb22df.jpg";